/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCashRegister, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CashRegistersController.
 */
export class CashRegistersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /cash_registers:prefill
     */
    public createPrefilled(): Promise<Result<ApiCashRegister>> {
        return this.http.post<Result<ApiCashRegister>, undefined>('/cash_registers:prefill', undefined);
    }

    /**
     * Calls GET /cash_registers:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiCashRegister>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiCashRegister>>>('/cash_registers:query', query);
    }

    /**
     * Calls POST /cash_registers:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiCashRegister>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCashRegister>>, ListRequest>('/cash_registers:query', listRequest, query);
    }

    /**
     * Calls GET /cash_registers/{cashRegisterId}/tse_client_id/ping
     */
    public pingTse(cashRegisterId: string): Promise<Result<string>> {
        const query = new URLSearchParams();
        query.set('cashRegisterId', `${cashRegisterId}`);

        return this.http.get<Result<string>>(`/cash_registers/${cashRegisterId}/tse_client_id/ping`, query);
    }

    /**
     * Calls POST /cash_registers/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiCashRegister>>> {
        return this.http.post<Result<LockedContextDto<ApiCashRegister>>, undefined>(`/cash_registers/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /cash_registers/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiCashRegister>> {
        return this.http.post<Result<ApiCashRegister>, undefined>(`/cash_registers/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /cash_registers/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiCashRegister[]>> {
        return this.http.post<Result<ApiCashRegister[]>, string[]>('/cash_registers/locks', ids);
    }

    /**
     * Calls POST /cash_registers/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/cash_registers/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /cash_registers/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cash_registers/${primaryId}/locks`);
    }

    /**
     * Calls GET /cash_registers/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiCashRegister>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiCashRegister>>(`/cash_registers/${primaryId}`, query);
    }

    /**
     * Calls POST /cash_registers
     */
    public add(dto: ApiCashRegister): Promise<Result<ApiCashRegister>> {
        return this.http.post<Result<ApiCashRegister>, ApiCashRegister>('/cash_registers', dto);
    }

    /**
     * Calls PUT /cash_registers/{primaryId}
     */
    public update(dto: ApiCashRegister, primaryId: string): Promise<Result<ApiCashRegister>> {
        return this.http.put<Result<ApiCashRegister>, ApiCashRegister>(`/cash_registers/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /cash_registers
     */
    public putRange(dtos: ApiCashRegister[]): Promise<Result<ApiCashRegister[]>> {
        return this.http.patch<Result<ApiCashRegister[]>, ApiCashRegister[]>('/cash_registers', dtos);
    }

    /**
     * Calls DELETE /cash_registers/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cash_registers/${primaryId}`);
    }

    /**
     * Calls POST /cashregisters:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiCashRegister>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCashRegister>>, ListRequestWithIds>('/cashregisters:batch', listRequest, query);
    }
}
